import common from './common'

// 背景色
function getColor() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 ? this.siteCodeInfo[0].BACK_COLOR : ''
}

// ダウンロードボタンの状態
function getDisableFlg() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 && [1, 2].includes(this.siteCodeInfo[0].PRICING_METHOD) ? false : true
}

// ハイフンを取り除く
function deleteHyphen(value) {
  if (value.includes('-')) {
      // '-'を除く
      const regex = /-/g
      return value.replace(regex, '')
  } else {
      return value
  }
}

// ダウンロードボタン押下
async function submitReportDownloadForm(obj) {
  //エラーフラグを初期化
  obj.setErrorFlg(false)

  //エラーメッセージを初期化
  obj.error.required_applyId = false
  obj.error.required_pickupTell = false
  obj.error.invalid_pickupTell = false
  obj.error.required_email = false
  obj.error.invalid_email = false

  //申込ID必須チェック
  if (obj.applyId === '') {
    obj.error.required_applyId = true
    obj.setErrorFlg(true)
  }

  //メールアドレス必須チェック
  if (obj.email === '') {
    obj.setErrorFlg(true)
    obj.error.required_email = true
  } else if (!common.isMailAddress(obj.email)) {
    //メールアドレス形式チェック
    obj.setErrorFlg(true)
    obj.error.invalid_email = true
  }

  //電話番号必須チェック
  if (obj.pickupTell === '') {
    obj.setErrorFlg(true)
    obj.error.required_pickupTell = true
  } else if (!(common.isHankakuNum(obj.pickupTell) && common.isTelMaxLength(obj.pickupTell))) {
    //電話番号 半角数字10～11桁チェック
    obj.setErrorFlg(true)
    obj.error.invalid_pickupTell = true
  }

  if(obj.errorFlg())return

  const params = new URLSearchParams({
    site_code: process.env.VUE_APP_SITE_CODE,
    applyId: obj.applyId,
    email: obj.email,
    pickupTell: obj.pickupTell
  })

  let url = common.constant.GET_APP_INFO_URL + params

  let func = async (response) => {
    if(response.data.applyInfo.length > 0){
      await contractDownload(obj, response.data)
    }else{
      obj.setErrorFlg(true)
      obj.error.invalid_input = true
    }
  }
  // API呼び出し
  await common.executeAxiosGet(url, func, obj)
}

// 契約書ダウンロード
async function contractDownload(obj, data) {
  let applyInfo = data.applyInfo[0]
  let applyMediumItems = data.applyMediumItems
  let applySmallItems = data.applySmallItems

  let mediumItems = [];

  // ITEMで一意の配列
  let mItems = applyMediumItems.filter((element, index, self) => self.findIndex(
    (dataElement) => dataElement.ITEM === element.ITEM ) === index
  );

  for (let mItem of mItems) {
    let details = [];

    for (let applyMediumItem of applyMediumItems.filter(x => x.ITEM == mItem.ITEM)) {
      details.push({
        'fee_kbn': applyMediumItem.FEE_KBN,
        'fee_kbn_nm': applyMediumItem.FEE_KBN_NM,
        'fee_category': applyMediumItem.FEE_CATEGORY,
        'fee_cat_nm': applyMediumItem.FEE_CATEGORY_NM,
        'fee': applyMediumItem.FEE
      })
    }
    mediumItems.push({
      'item': mItem.ITEM,
      'item_nm': mItem.ITEM_NM,
      'quantity': mItem.QUANTITY,
      'details': details
    })
  }

  let smallItems = [];

  for (let applySmallItem of applySmallItems) {
    smallItems.push({
      'item': applySmallItem.ITEM,
      'item_nm': applySmallItem.ITEM_NM,
      'fee_kbn': applySmallItem.FEE_KBN,
      'fee_kbn_nm': applySmallItem.FEE_KBN_NM,
      'fee_category': applySmallItem.FEE_CATEGORY,
      'quantity': applySmallItem.QUANTITY,
      'fee': applySmallItem.FEE
    })
  }

  let params = {
      font_style: common.constant.FONT_STYLE,
      contract_company_name: applyInfo.CONTRACTOR_CORPORATION_NAME? applyInfo.CONTRACTOR_CORPORATION_NAME:applyInfo.CORPORATION_NAME,
      pickup_pref: applyInfo.PICKUP_PREF,
      pickup_address1: applyInfo.PICKUP_ADDRESS1,
      address: applyInfo.ADDRESS,
      building_name: applyInfo.BUILDING_NAME,
      medium_items: mediumItems,
      small_items: smallItems,
      commission_sgw: applyInfo.CASH_ON_DELIVERY_FEE,
      site_code: process.env.VUE_APP_SITE_CODE,
      sales_tax_rate: applyInfo.SALES_TAX_RATE,
      pricing_method: applyInfo.PRICING_METHOD,
      medium_small_flat_price: applyInfo.MEDIUM_SMALL_FLAT_PRICE
  }

  let url = common.constant.DOWNLOAD_CONTRACT_URL

  await common.contractDownload(obj, url, params, true)

}

// 画面遷移ボタン背景色
function getNextPageColor() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 ? this.siteCodeInfo[0].NEXT_PAGE_BTN_COLOR : ''
}


export default {
    common,
    getColor,
    getDisableFlg,
    deleteHyphen,
    getNextPageColor,
    submitReportDownloadForm
}
